import React from 'react'

import { useCustomerDelete } from 'features/customers/hooks/useCustomerDelete'
import { useNavigate } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { ConfirmModal } from 'components/_base'

type CustomerDeleteConfirmProps = {
  open: boolean
  onClose: (...args: any[]) => any
}

const CustomerDeleteConfirm = ({ open, onClose }: CustomerDeleteConfirmProps) => {
  const navigate = useNavigate()
  const { mutateAsync: deleteCustomer } = useCustomerDelete()

  const handleDelete = async () => {
    await deleteCustomer()
    navigate(UrlProvider.getUrl('customers'))
  }

  return <ConfirmModal onClose={onClose} onConfirm={handleDelete} open={open} title="Do you want to remove customer?" />
}

export default CustomerDeleteConfirm
